import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import LanguagePersistBridge from "@/components/LanguagePersistBridge";
import Layout from "@/components/Layout";
import ErrorBoundary from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import Intake from "@/pages/Intake";
import Deborah from "@/pages/Deborah";
import Glossary from "@/pages/Glossary";
import Roles from "@/pages/Roles";
import Paths from "@/pages/Paths";
import MyCase from "@/pages/MyCase";
import Summarize from "@/pages/Summarize";
import Resources from "@/pages/Resources";
import Learn from "@/pages/Learn";
import Practice from "@/pages/Practice";
import WhatIf from "@/pages/WhatIf";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CaseLaw from "@/pages/CaseLaw";
import AuthCallback from "@/pages/AuthCallback";
import Waiver from "@/pages/Waiver";
import Navigator from "@/pages/Navigator";
import Legal from "@/pages/Legal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Pricing from "@/pages/Pricing";
import Research from "@/pages/Research";
import Builder from "@/pages/Builder";
import Sessions from "@/pages/Sessions";
import CourtReadyReader from "@/pages/CourtReadyReader";
import { PaywallGate } from "@/components/PaywallGate";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Google OAuth callback (hash-based) before normal routing
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/intake" element={<Intake />} />
        <Route path="/deborah" element={<Deborah />} />
        <Route path="/glossary" element={<Glossary />} />
        <Route path="/roles" element={<Roles />} />
        <Route path="/paths" element={<Paths />} />
        <Route path="/my-case" element={<MyCase />} />
        <Route path="/summarize" element={<PaywallGate feature="summarize"><Summarize /></PaywallGate>} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/learn" element={<Learn />} />
        <Route path="/practice" element={<PaywallGate feature="practice"><Practice /></PaywallGate>} />
        <Route path="/what-if" element={<WhatIf />} />
        <Route path="/case-law" element={<CaseLaw />} />
        <Route path="/waiver" element={<Waiver />} />
        <Route path="/navigator" element={<Navigator />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/research" element={<Research />} />
        <Route path="/builder" element={<Builder />} />
        <Route path="/sessions" element={<Sessions />} />
        <Route path="/court-ready" element={<CourtReadyReader />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <LanguagePersistBridge />
            <Toaster position="top-right" richColors closeButton />
            <ErrorBoundary>
              <AppRouter />
            </ErrorBoundary>
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
